import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: 0,
        minWidth: 600,
        maxWidth: 700,
    },
    dialogTitle: {
        padding: theme.spacing(2, 2, 1.5),
    },
    dialogContent: {
        padding: theme.spacing(0, 2, 2),
        paddingTop: theme.spacing(2),
        maxHeight: 400,
        overflowY: 'auto',
    },
    listRoot: {
        paddingTop: 0,
        paddingBottom: 0,
    },
    listItem: {
        alignItems: 'flex-start',
        paddingTop: theme.spacing(1.5),
        paddingBottom: theme.spacing(1.5),
        paddingLeft: 0,
        paddingRight: 0,
        display: 'flex',
        flexDirection: 'row',
    },
    timestamp: {
        minWidth: 180,
        fontSize: theme.typography.caption.fontSize,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(2),
        alignSelf: 'flex-start',
        paddingTop: theme.spacing(0.5),
        flexShrink: 0,
    },
    avatarContainer: {
        minWidth: 40,
        marginRight: theme.spacing(1.5),
        alignSelf: 'flex-start',
        flexShrink: 0,
    },
    avatar: {
        width: 32,
        height: 32,
        fontSize: theme.typography.caption.fontSize,
        backgroundColor: theme.palette.grey[300],
        color: theme.palette.text.primary,
        fontWeight: 500,
    },
    listItemText: {
        flex: 1,
        margin: 0,
        '& .MuiListItemText-primary': {
            marginBottom: theme.spacing(0.5),
            '& strong': {
                fontWeight: 600,
            },
        },
        '& .MuiListItemText-secondary': {
            display: 'block',
            lineHeight: 1.4,
        },
    },
    dialogActions: {
        padding: theme.spacing(2),
        justifyContent: 'flex-end',
    },
    closeButton: {
        backgroundColor: theme.palette.grey[200],
        color: theme.palette.text.primary,
        '&:hover': {
            backgroundColor: theme.palette.grey[300],
        },
    },
}));

export default useStyles;
